var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0049 30.4975C60.0049 47.0612 46.5735 60.5 30.0025 60.5C13.4339 60.5 0 47.0612 0 30.4975C0 13.9265 13.4339 0.5 30.0025 0.5C46.5735 0.5 60.0049 13.9265 60.0049 30.4975ZM28.8123 43.6284V17.3271H31.1964V41.281H37.1714V43.6284H28.8123ZM20.4258 24.5104C22.4175 24.5104 24.029 22.8965 24.029 20.9171C24.029 18.9303 22.4175 17.3164 20.4258 17.3164C18.4489 17.3164 16.8325 18.9303 16.8325 20.9171C16.8325 22.8965 18.4489 24.5104 20.4258 24.5104ZM30.0066 5.375C30.296 5.375 30.8945 5.37991 31.1962 5.39462H31.1937V7.73458C30.9215 7.72722 30.2813 7.72231 30.0041 7.72231C23.9261 7.72231 18.2136 10.0868 13.9114 14.3914C9.60923 18.6912 7.23985 24.4086 7.23985 30.4891C7.23985 36.5695 9.60923 42.2845 13.9114 46.5842C18.2161 50.8839 23.9286 53.2484 30.0041 53.2484C42.0399 53.2484 51.9271 43.8592 52.7243 32.0196V31.6811H37.1859V29.351H54.1052L55.1084 29.3436V30.4891C55.1084 37.1925 52.506 43.4986 47.7672 48.2374C43.0137 52.9835 36.7051 55.5933 30.0041 55.5933C23.3056 55.5933 16.997 52.986 12.2411 48.2374C7.50475 43.4986 4.90234 37.1925 4.90234 30.4891C4.90234 16.6431 16.168 5.375 30.0066 5.375Z",
    fill: "#00A3A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLg);
export default __webpack_public_path__ + "static/media/Lg.e570980e6c676d50e113f128b62e501a.svg";
export { ForwardRef as ReactComponent };